<template>
    <div class="big-content page" :class="{'big-content--open' : open}">
        <header class="header clearfix">
            <nav class="top-navigation">
                <ul class="top-navigation__list">
                    <li class="top-navigation__list-item">
                        <button @click="closeOverlay"
                                type="button"
                                class="top-navigation__list-item-link top-navigation__icon--item-close
                                icon icon--hover top-navigation__icon">
                            {{ content.closeOverlayLabel }}</button>
                    </li>
                </ul>
                <a class="d-none d-md-block" href="https://kambly.ch">
                    <img class="header__logo" src="../assets/images/frontend/logo_kambly.webp" alt="">
                </a>
                <a class="d-block d-md-none" href="https://kambly.ch">
                    <img class="header__logo-mobile" src="../assets/images/frontend/logo_kambly_small.webp" alt="">
                </a>            </nav>
        </header>
        <div class="article">
            <div class="container article__element">
                <div class="row justify-content-center">
                    <div class="col-md-10 col-lg-8 col-xl-6 wysiwyg">
                        <h2 class="heading heading--2 products-type-overview__title">{{ overlayContent.title }}</h2>
                        <div class="text">
                            <p v-html="overlayContent.firstText"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="overlayContent.imageStory" class="container article__element-image">
                <div class="row">
                    <div :class="css">
                        <img :src="`${ this.overlayContent.imageStory }`" alt="" class="img-fluid d-none d-md-block"> <img :src="`${ this.overlayContent.imageStory }`" alt="" class="img-fluid d-block d-md-none">
                    </div>
                </div>
            </div>
            <div v-if="!overlayContent.imageStory && overlayContent.image && !overlayContent.image2" class="container article__element-image">
                <div class="row">
                    <div :class="css">
                        <img :src="`${ this.overlayContent.image }`" alt="" class="img-fluid d-none d-md-block"> <img :src="`${ this.overlayContent.image }`" alt="" class="img-fluid d-block d-md-none">
                    </div>
                </div>
            </div>
            <div v-if="overlayContent.image2" class="container article__element-image">
                <div class="row">
                    <div class="col-12 col-md-5 offset-md-1 col-lg-4 offset-lg-2 article--element">
                        <img :src="`${ this.overlayContent.image }`" alt="" class="img-fluid d-none d-md-block"> <img :src="`${ this.overlayContent.image }`" alt="" class="img-fluid d-block d-md-none">
                    </div>
                    <div class="col-12 col-md-5 col-lg-4">
                        <img :src="`${ this.overlayContent.image2 }`" alt="" class="img-fluid d-none d-md-block"> <img :src="`${ this.overlayContent.image2 }`" alt="" class="img-fluid d-block d-md-none">
                    </div>
                </div>
            </div>
            <img :src="`${ this.overlayContent.icon }`" alt="" class="content-icon">
            <div v-if="overlayContent.secondText" class="container article__element">
                <div class="row justify-content-center">
                    <div class="col-md-10 col-lg-8 col-xl-6 wysiwyg">
                        <div class="text">
                            <p>{{ overlayContent.secondText }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                open: false
            }
        },
        computed: {
            ...mapGetters([
                'overlayContent',
                'overlayContentTitle',
                'content'

            ]),
            css() {
                if(this.overlayContent.bigImage) {
                    return 'col-12 col-lg-10 offset-lg-1'
                } else {
                    return 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2'
                }
            }
        },
        methods: {
            ...mapActions(['closeOverlay']),
            close() {
                this.open = false;
            }
        },
        mounted() {
            setTimeout(() => {
                document.body.classList.add('no-scroll')
                this.open = true;
            }, 50)
        }
    }
</script>

<style lang="scss">
    .big-content {
        position: fixed;
        overflow-y: scroll;
        top: 0; right: 0; bottom: 0; left: 0;
        z-index: 1000;
        background-color: white;
        padding-bottom: 100px;
        visibility: hidden;
        opacity: 0;

        &.page {
            padding-top: 100px;
        }

        &--open {
            visibility: visible;
            opacity: 1;
            transition: transform 0.2s, opacity 0.2s;
        }

        .header {
            position: absolute;
            background: transparent;
        }

        .article {
              padding-bottom: 100px;

          &--element {
            margin-bottom: 30px;
          }
        }

      .content-icon {
        width: 100%;

        @media screen and (min-width: 768px) {
          height: 100px;
          width: auto;
          position: fixed;
          bottom: 20px;
          right: 15px;
        }
      }
    }
</style>


